import aa from 'search-insights';
import { getAnonymousId, getCustomerId } from '@js/utilities/trackingIdentity';
import { handleJsonParse } from '@js/utilities/handleJson';

aa('init', {
    appId: window.config.algolia.app_id,
    apiKey: window.config.algolia.search_api_key,
});

function sendEventToAlgolia(eventType, eventName, payload) {
    const index = window.config.algolia.products_indice;
    const eventData = {
        userToken: getAnonymousId() || undefined,
        authenticatedUserToken: getCustomerId() || undefined,
        eventName: eventName,
        index: index,
        ...payload,
    };

    aa(eventType, eventData);
}

if (process.env.NODE_ENV === 'production') {
    window.addEventListener('datalayer.view_item', (e) => {
        const product = handleJsonParse(e.detail.product);
        sendEventToAlgolia('viewedObjectIDs', 'Product Viewed', { objectIDs: [product.id] });
    });

    window.addEventListener('datalayer.add_to_cart', (e) => {
        // const product = JSON.parse(e.detail.productData);
        const product = e.detail.productData;
        sendEventToAlgolia('addedToCartObjectIDs', 'Product Added to Cart', {
            objectIDs: [product.product_id],
        });
    });

    document.addEventListener('ProductClicked', (e) => {
        const { productID } = e.detail;
        sendEventToAlgolia('clickedObjectIDs', 'Product Clicked', { objectIDs: [productID] });
    });

    window.addEventListener('datalayer.purchase', (e) => {
        const { products } = e.detail;
        sendEventToAlgolia('convertedObjectIDs', 'Product Purchased', {
            objectIDs: products.map((el) => el.product_id),
        });
    });
}
